import '../../less/common.less';
import '../../less/footer.less';
import './index.less';

import $ from 'jquery';
import '../../js/nav';
import '../../js/switch-lang';


function initDom(){
    $('.info .text').addClass('hidden');
    $('.info .text.understand').removeClass('hidden').addClass('show');
    $('.menu-opt.understand').addClass('selected');
    // selected option in menu
    $('.menu-opt').on('click', function() {
        console.log("i'm in");
        $('.menu-opt').removeClass('selected');
        $(this).addClass('selected');
    });

    // switch content displayed on selection
    $('.info .menu-opt.understand').on('click', function() {
        $('.info .text').removeClass('show').addClass('hidden');
        $('.info .text.understand').removeClass('hidden').addClass('show');
    });
    $('.menu-opt.ceo').on('click', function() {
        $('.info .text').removeClass('show').addClass('hidden');
        $('.info .text.ceo').removeClass('hidden').addClass('show');
    });
    $('.menu-opt.history').on('click', function() {
        $('.info .text').removeClass('show').addClass('hidden');
        $('.info .text.history').removeClass('hidden').addClass('show');
    });
}

initDom();




